import { Button, ButtonProps, CircularProgress } from "@mui/material";
import { strings } from "../localization";

type LoadingButtonProps = { loading: boolean } & ButtonProps;

const LoadingButton = ({ loading, children, ...other }: LoadingButtonProps) => {
  return (
    <Button disabled={loading} {...other}>
      {children}
      <CircularProgress
        size={20}
        style={{
          display: loading ? "inline-block" : "none",
          position: "absolute",
          alignSelf: "center",
        }}
      />
    </Button>
  );
};

export default LoadingButton;
